import { BrowserRouter } from 'react-router-dom';
import './App.css';
import { Game } from "./components";

function App() {
  return (
    <BrowserRouter>
      <Game />
    </BrowserRouter>
  );
}

export default App;
